exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location-map[data-v-442febc0] {\n  height: 50vh;\n  min-height: 300px;\n}\n.left-panel[data-v-442febc0] {\n  max-height: 50vh;\n}\n.map-help[data-v-442febc0] {\n  z-index: 999;\n  top: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 10px;\n  border-radius: 10px;\n}\n.map-search[data-v-442febc0] {\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  z-index: 500;\n@media (min-width: 768px) {\n    width: 50%;\n}\n}\n", ""]);

// exports
